export default __webpack_public_path__ + "static/media/pin.2190fcd7.svg";